"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Link_1 = require("../../Link");
var GroupSpacer_1 = require("./GroupSpacer");
var stylesImport = require("./GroupShowAll.scss");
var styles = stylesImport;
var GroupShowAll = (function (_super) {
    tslib_1.__extends(GroupShowAll, _super);
    function GroupShowAll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupShowAll.prototype.render = function () {
        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, showAllLinkText = _a.showAllLinkText;
        if (group) {
            return (React.createElement("div", { className: Utilities_1.css('ms-groupFooter', styles.root) },
                GroupSpacer_1.GroupSpacer({ count: groupLevel }),
                React.createElement(Link_1.Link, { onClick: this._onSummarizeClick }, showAllLinkText)));
        }
        return null;
    };
    GroupShowAll.prototype._onSummarizeClick = function (ev) {
        this.props.onToggleSummarize(this.props.group);
        ev.stopPropagation();
        ev.preventDefault();
    };
    GroupShowAll.defaultProps = {
        showAllLinkText: 'Show All'
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], GroupShowAll.prototype, "_onSummarizeClick", null);
    return GroupShowAll;
}(Utilities_1.BaseComponent));
exports.GroupShowAll = GroupShowAll;
//# sourceMappingURL=GroupShowAll.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/GroupedList/GroupShowAll.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/GroupedList/GroupShowAll.js
// module chunks = 1